const allDistricts = [
  {
    key: '01',
    value: 'Bydel Gamle Oslo',
    uri: 'gamleoslo',
  },
  {
    key: '02',
    value: 'Bydel Grünerløkka',
    uri: 'grunerlokka',
  },
  {
    key: '03',
    value: 'Bydel Sagene',
    uri: 'sagene',
  },
  {
    key: '04',
    value: 'Bydel St. Hanshaugen',
    uri: 'sthanshaugen',
  },
  {
    key: '05',
    value: 'Bydel Frogner',
    uri: 'frogner',
  },
  {
    key: '06',
    value: 'Bydel Ullern',
    uri: 'ullern',
  },
  {
    key: '07',
    value: 'Bydel Vestre Aker',
    uri: 'vestreaker',
  },
  {
    key: '08',
    value: 'Bydel Nordre Aker',
    uri: 'nordreaker',
  },
  {
    key: '09',
    value: 'Bydel Bjerke',
    uri: 'bjerke',
  },
  {
    key: '10',
    value: 'Bydel Grorud',
    uri: 'grorud',
  },
  {
    key: '11',
    value: 'Bydel Stovner',
    uri: 'stovner',
  },
  {
    key: '12',
    value: 'Bydel Alna',
    uri: 'alna',
  },
  {
    key: '13',
    value: 'Bydel Østensjø',
    uri: 'ostensjo',
  },
  {
    key: '14',
    value: 'Bydel Nordstrand',
    uri: 'nordstrand',
  },
  {
    key: '15',
    value: 'Bydel Søndre Nordstrand',
    uri: 'sondrenordstrand',
  },
];

export default allDistricts;
